import { EnumSubTipoComunicacion, EnumTipoComunicacion } from '../../../api'
import { ComunicationModel } from '../../../api/Argentia/model/comunication/comunications'
import { enumEnumToValueNumber } from '../../../helpers'

export const comunicationModelListMapper = (
  comunications: ComunicationModel[]
): ComunicationModel[] => {
  return comunications.map(comunicationModelItemMapper)
}

export const comunicationModelItemMapper = (comunication: ComunicationModel): ComunicationModel => {
  return {
    ...comunication,
    subjectId: comunication.subject?.id,
    subjectDesc: comunication.subject?.description,
    comunicationSubType: enumEnumToValueNumber(
      EnumSubTipoComunicacion,
      comunication.comunicationSubType
    )!,
    comunicationType: enumEnumToValueNumber(EnumTipoComunicacion, comunication.comunicationType)!
  }
}
